import React from 'react'

import './navbar.css'
import 'font-awesome/css/font-awesome.min.css'

class Navbar extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            menuOpen: false
        }
    }

    displayUnderline = (e) => {
        let identifier = e.currentTarget.id
        let width = document.getElementById(identifier).offsetWidth
        width = String(width) + 'px'
        identifier += '_underline'
        
        document.getElementById(identifier).style.width = width
        document.getElementById(identifier).style.visibility = 'visible'
    }
    
    hideUnderline = (e) => {
        let identifier = e.currentTarget.id
        identifier += '_underline'
        document.getElementById(identifier).style.visibility = 'hidden'
    }

    switch = async(e) => {
        let state = !this.state.menuOpen
        
        if (state) {
            document.getElementById('dropdown').style.display = 'block';
            document.getElementById('darken').style.display = 'block';

            document.getElementById('bar-1').classList.add('changed')
            document.getElementById('bar-2').classList.add('changed')
            document.getElementById('bar-3').classList.add('changed')
        } else {
            document.getElementById('dropdown').style.display = 'none';
            document.getElementById('darken').style.display = 'none';

            document.getElementById('bar-1').classList.remove('changed')
            document.getElementById('bar-2').classList.remove('changed')
            document.getElementById('bar-3').classList.remove('changed')
        }
        
        this.setState({ menuOpen: state })
    }
        
    render() {
        return (
            <div className = 'nav-bar'>
                <div className = 'bottom-bar' id = 'bottom-bar'>
                    <div className = 'left-panel'>
                        <img id = 'logo' className = 'normal' src = 'marketplace-logo.png' alt = 'marketplace-logo' />
                    </div>
                    <div className = 'right-panel'>
                        <ul>
                            <li id = 'exchange' onMouseOver = { this.displayUnderline } onMouseOut = { this.hideUnderline }>
                                <a href = 'https://marketplace.sinegy.com/exchange' rel = 'noreferrer' target = '_blank'>
                                    Exchange
                                </a>
                                <div id = 'exchange_underline' className = 'underline'></div>
                            </li>
                            <li id = 'trading_rule' onMouseOver = { this.displayUnderline } onMouseOut = { this.hideUnderline }>
                                <a href = 'https://marketplace.sinegy.com/trading-rules' rel = 'noreferrer' target = '_blank'>
                                    Trading Rules
                                </a>
                                <div id = 'trading_rule_underline' className = 'underline'></div>
                            </li>
                            <li id = 'privacy_policy' onMouseOver = { this.displayUnderline } onMouseOut = { this.hideUnderline }>
                                <a href = 'https://marketplace.sinegy.com/privacy-policy' rel = 'noreferrer' target = '_blank'>
                                    Privacy Policy
                                </a>
                                <div id = 'privacy_policy_underline' className = 'underline'></div>
                            </li>
                            <li id = 'guide' onMouseOver = { this.displayUnderline } onMouseOut = { this.hideUnderline }>
                                <a href = 'https://sinegy.zendesk.com/hc/en-us/categories/360000778051-FAQ' rel = 'noreferrer' target = '_blank'>
                                    Guide
                                </a>
                                <div id = 'guide_underline' className = 'underline'></div>
                            </li>
                        </ul>
                        
                    </div>
                </div>

                <div className = 'mobile-nav' id = 'mobile-nav'>
                    <div className = 'container' onClick = { this.switch }>
                        <div className = 'bar1' id = 'bar-1'></div>
                        <div className = 'bar2' id = 'bar-2'></div>
                        <div className = 'bar3' id = 'bar-3'></div>
                    </div>

                    <img id = 'logo' className = 'normal' src = 'marketplace-logo.png' alt = 'marketplace-logo' />

                    <div className = 'container'>
                        <div className = 'hidden-bar'></div>
                        <div className = 'hidden-bar'></div>
                        <div className = 'hidden-bar'></div>
                    </div>
                </div>

                <div className = 'dropdown' id = 'dropdown'>
                    <br></br>
                    <a href = 'https://sinegy.com' rel = 'noreferrer' target = '_blank'>
                        Corporate
                    </a>
                    <hr></hr>
                    <a href = 'https://sinegy.com/announcements' rel = 'noreferrer' target = '_blank'>
                        Announcement
                    </a>
                    <hr></hr>
                    <a href = 'https://marketplace.sinegy.com/crypto-intro' rel = 'noreferrer' target = '_blank'>
                        Assets
                    </a>
                    <hr></hr>
                    <a href = 'https://marketplace.sinegy.com/login' rel = 'noreferrer' target = '_blank'>
                        <button className = 'login'>
                            Login
                        </button>
                    </a>
                    <br></br>
                    <a href = 'https://marketplace.sinegy.com/sign-up' rel = 'noreferrer' target = '_blank'>
                        <button className = 'create-account'>
                            Create an Account
                            <i style = {{ float: 'right' }} className = 'fa fa-arrow-right'></i>
                        </button>
                    </a>
                </div>

                <div className = 'darken' id = 'darken'></div>
            </div>
        )
    }
}

export default Navbar
